import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { selectActiveProfileTab, setActiveTab } from '@/store/slices/profileSlice'
import { PROFILE_TABS } from '@/config/profile'
import { cn } from '@/lib/utils'

export function ProfileTabs() {
	const dispatch = useAppDispatch()
	const activeTab = useAppSelector(selectActiveProfileTab)

	return (
		<nav className='grid grid-cols-1 gap-2 sm:grid-cols-3 sm:gap-3' aria-label='Profile sections'>
			{PROFILE_TABS.map(({ id, label, icon: Icon }) => {
				const isActive = activeTab === id

				return (
					<button
						key={id}
						type='button'
						onClick={() => dispatch(setActiveTab(id))}
						className={cn('group relative w-full overflow-hidden rounded-xl border p-0.5 transition-colors', isActive ? 'border-primary' : 'border-border')}
					>
						<span
							className={cn(
								'relative flex items-center justify-center gap-2 overflow-hidden rounded-[10px] px-4 py-2.5',
								isActive
									? 'bg-card bg-[radial-gradient(circle_3rem_at_50%_125%_in_hsl_shorter_hue,transparent_0%,hsl(var(--secondary))_100%),linear-gradient(90deg,hsl(var(--secondary)/0.5),hsl(var(--secondary)/0.5))]'
									: 'bg-secondary',
							)}
						>
							<Icon
								className={cn(
									'h-6 w-6 shrink-0',
									isActive ? 'text-primary' : 'text-icon-muted transition-colors duration-200 ease-in-out group-hover:text-primary',
								)}
							/>
							<span className={cn('text-sm font-medium tracking-[-0.21px]', isActive ? 'text-foreground' : 'text-muted-foreground')}>{label}</span>
							<span
								className={cn(
									'absolute bottom-0.5 left-1/2 h-0.5 w-6 -translate-x-1/2 rounded-full transition-[width,background-color,box-shadow] duration-200 ease-in-out group-hover:w-8',
									isActive
										? 'bg-primary shadow-[0_0_20px_9px_hsl(var(--primary))]'
										: 'bg-border group-hover:bg-primary group-hover:shadow-[0_0_6px_2px_hsl(var(--primary)/0.55)]',
								)}
								aria-hidden
							/>
						</span>
					</button>
				)
			})}
		</nav>
	)
}
